import React, { useEffect, useState } from "react"
import { FaSave } from "react-icons/fa"
import { MdCancel } from "react-icons/md"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap"

const StaffModal = ({
  open,
  close,
  onSubmit,
  formData,
  setFormData,
  mode,
  Roles,
}) => {
  const [errors, setErrors] = useState({})

  useEffect(() => {
    setErrors({})
  }, [open])

  const isView = mode === "view"

  const validate = () => {
    let newErrors = {}

    if (!formData?.name?.trim()) {
      newErrors.name = "Name is required"
    }

    if (!formData?.email?.trim()) {
      newErrors.email = "Email is required"
    } else if (!/\S+@\S+\.\S+/.test(formData.email.trim())) {
      newErrors.email = "Invalid email format"
    }

    if (!formData?.phone) {
      newErrors.phone = "Phone number is required"
    } else if (formData.phone.length < 10) {
      newErrors.phone = "Phone number must be 10 digits"
    }

    if (!formData?.joiningDate) {
      newErrors.joiningDate = "Joining date is required"
    }

    if (!formData?.designation?.trim()) {
      newErrors.designation = "Designation is required"
    }

    if (!formData?.id) {
      if (!formData?.password?.trim()) {
        newErrors.password = "Password is required"
      } else if (formData.password.trim().length < 6) {
        newErrors.password = "Password must be at least 6 characters"
      }
    }

    if (!formData?.roleId) {
      newErrors.roleId = "Role is required"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = () => {
    if (isView) return close()

    if (validate()) {
      onSubmit()
    }
  }

  const handleChange = e => {
    const { name, value } = e.target

    if (name === "phone") {
      setFormData({ ...formData, [name]: value.replace(/\D/g, "") })
    } else if (name === "address") {
      setFormData({ ...formData, [name]: value })
    } else {
      // Strip leading spaces so the field can never start with whitespace
      setFormData({ ...formData, [name]: value.replace(/^\s+/, "") })
    }
  }

  return (
    <Modal isOpen={open} toggle={close} size="xl" centered>
      <ModalHeader toggle={close}>
        {isView ? "View" : formData?.id ? "Edit" : "Add"} Staff
      </ModalHeader>

      <ModalBody>
        <Row>
          <Col md="6">
            <Label>
              Name <span className="text-danger">*</span>
            </Label>
            <Input
              name="name"
              value={formData?.name || ""}
              onChange={handleChange}
              disabled={isView}
            />
            {errors.name && (
              <small className="text-danger">{errors.name}</small>
            )}
          </Col>

          <Col md="6">
            <Label>
              Email <span className="text-danger">*</span>
            </Label>
            <Input
              type="email"
              name="email"
              value={formData?.email || ""}
              onChange={handleChange}
              disabled={isView}
            />
            {errors.email && (
              <small className="text-danger">{errors.email}</small>
            )}
          </Col>

          <Col md="6" className="mt-3">
            <Label>
              Phone Number <span className="text-danger">*</span>
            </Label>
            <Input
              type="tel"
              name="phone"
              value={formData?.phone || ""}
              onChange={handleChange}
              disabled={isView}
              maxLength={10}
            />
            {errors.phone && (
              <small className="text-danger">{errors.phone}</small>
            )}
          </Col>

          <Col md="6" className="mt-3">
            <Label>
              Role <span className="text-danger">*</span>
            </Label>

            <Input
              type="select"
              name="roleId"
              value={formData?.roleId || ""}
              onChange={handleChange}
              disabled={isView}
            >
              <option value="">Select Role</option>
              {Roles?.map(item => (
                <option value={item?.id} key={item?.id}>
                  {item?.roleName}
                </option>
              ))}
            </Input>

            {errors.roleId && (
              <small className="text-danger">{errors.roleId}</small>
            )}
          </Col>

          <Col md="6" className="mt-3">
            <Label>
              Joining Date <span className="text-danger">*</span>
            </Label>
            <Input
              type="date"
              name="joiningDate"
              value={formData?.joiningDate || ""}
              onChange={handleChange}
              disabled={isView}
            />
            {errors.joiningDate && (
              <small className="text-danger">{errors.joiningDate}</small>
            )}
          </Col>

          <Col md="6" className="mt-3">
            <Label>
              Designation <span className="text-danger">*</span>
            </Label>
            <Input
              name="designation"
              value={formData?.designation || ""}
              onChange={handleChange}
              disabled={isView}
            />
            {errors.designation && (
              <small className="text-danger">{errors.designation}</small>
            )}
          </Col>

          <Col md="6" className="mt-3">
            <Label>
              Password <span className="text-danger">*</span>
            </Label>
            <Input name="password" onChange={handleChange} disabled={isView} />
            {errors.password && (
              <small className="text-danger">{errors.password}</small>
            )}
          </Col>

          <Col md="12" className="mt-3">
            <Label>Address</Label>
            <Input
              type="textarea"
              name="address"
              rows="3"
              value={formData?.address || ""}
              onChange={handleChange}
              disabled={isView}
            />
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>
        {!isView && (
          <Button className="btn-blue" onClick={handleSubmit}>
            <FaSave className="me-1" /> Save
          </Button>
        )}
        <Button className="btn-secondary" onClick={close}>
          <MdCancel className="me-1" /> {isView ? "Close" : "Cancel"}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default StaffModal
